import { render, staticRenderFns } from "./requisition_create.vue?vue&type=template&id=d90ad9be&"
import script from "./requisition_create.vue?vue&type=script&lang=js&"
export * from "./requisition_create.vue?vue&type=script&lang=js&"
import style0 from "./requisition_create.vue?vue&type=style&index=0&id=d90ad9be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports